/*
 * Module for uploading and deleting content in Amazon S3
 */

define(["backbone", "jquery", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  $,
  Properties,
  Messenger,
) {
  "use strict";

  const ContentUploadModel = {};

  ContentUploadModel.contentUpload = Backbone.Model.extend(
    {},
    {
      MAX_SIZE: 21 * 1024 * 1024, // will eventually be pulled from DB
    },
  );

  Messenger.reqres.setHandler(
    "upload:content",
    function (uploadForm, fileName, fileSize, urlModel) {
      const kbId = Messenger.reqres.request("active:kb");
      const authorizationHeader = Messenger.reqres.request("authorization:header");
      const oData = new FormData(uploadForm);
      const languageId = urlModel.get("languageId");
      const touchPointId = urlModel.get("touchpointId") || urlModel.get("touchPointId");
      const csrfToken = Messenger.reqres.request("get:csrfToken");
      oData.append("kbId", kbId);
      if (touchPointId) {
        oData.append("touchPointId", touchPointId);
      }
      if (languageId) {
        oData.append("languageId", languageId);
      }
      if (csrfToken) {
        oData.append("_csrf", csrfToken);
      }
      const oReq = new XMLHttpRequest();
      //Hide the preview, since it's probably going to change
      Messenger.vent.trigger("hide:preview");
      Messenger.vent.trigger("show:saving:display");
      const requestUrl = Messenger.reqres.request("get:uploadUrl");
      oReq.open("POST", requestUrl, true);
      if (authorizationHeader) {
        oReq.setRequestHeader("Authorization", authorizationHeader);
      }
      if (csrfToken) {
        oReq.setRequestHeader("X-XSRF-TOKEN", csrfToken);
      }
      oReq.onload = function () {
        const response = JSON.parse(oReq.responseText);
        if (oReq.status === 200) {
          const uploadId = response.uploadId;
          const url = response.url;
          Messenger.vent.trigger(
            "content:upload:changed",
            true,
            fileName,
            fileSize,
            true,
            uploadId,
            url,
            urlModel,
          );
        } else {
          console.log("Upload failed! " + response.error);
          var errorMessage = response.error && response.error.message;
          Messenger.okDialog(errorMessage);
          Messenger.vent.trigger(
            "content:upload:changed",
            false,
            fileName,
            fileSize,
            false,
            "",
            "",
            urlModel,
          );
        }
        Messenger.vent.trigger("close:saving:display");
      };
      oReq.send(oData);
    },
  );

  Messenger.reqres.setHandler("delete:content", function (uploadId, urlModel) {
    Messenger.vent.trigger("content:upload:changed", true, "", 0, false, uploadId, "", urlModel);
  });

  return ContentUploadModel;
});
